import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import { DASHBOARD_RESOURCES } from 'constant';
import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';
import EditConfig from './submodules/allActions';
import { GET_ACTION, LOTTERY_RESOURCES } from '../lotteryHelper';

const LotteryActionsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={DASHBOARD_RESOURCES.lottery}
				configResourceName={LOTTERY_RESOURCES.lotteryActions}
				configActionName={GET_ACTION[LOTTERY_RESOURCES.lotteryActions]}
				path={path}
				component={EditConfig}
				exact
			/>
			<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.lottery]} />
		</Switch>
	);
};

export default LotteryActionsDashboard;
